import * as api from '../register_api_services/ComplianceDocuments.api';

const ok = (data, fallback) => ({
  success: true,
  message: data?.message || fallback,
  data: data?.data !== undefined ? data.data : data,
});

const fail = (error) => ({
  success: false,
  message: error,
});

export const getComplianceDocumentSetup = (params) => {
  return async () => {
    try {
      const data = await api.fetchComplianceDocumentSetup(params);
      return ok(data, 'Setup loaded.');
    } catch (error) {
      return fail(error);
    }
  };
};

export const saveComplianceDocumentSetup = (payload) => {
  return async () => {
    try {
      const data = await api.saveComplianceDocumentSetupApi(payload);
      return ok(data, 'Setup saved.');
    } catch (error) {
      return fail(error);
    }
  };
};

export const getComplianceDocuments = (params) => {
  return async () => {
    try {
      const data = await api.fetchComplianceDocuments(params);
      return { success: true, data: Array.isArray(data) ? data : [] };
    } catch (error) {
      return fail(error);
    }
  };
};

export const uploadComplianceDocument = (payload) => {
  return async () => {
    try {
      const data = await api.uploadComplianceDocumentApi(payload);
      return ok(data, 'File uploaded.');
    } catch (error) {
      return fail(error);
    }
  };
};

export const updateComplianceDocument = (id, payload) => {
  return async () => {
    try {
      const data = await api.updateComplianceDocumentApi(id, payload);
      return ok(data, 'Updated successfully.');
    } catch (error) {
      return fail(error);
    }
  };
};

export const deleteComplianceDocument = (id) => {
  return async () => {
    try {
      const data = await api.deleteComplianceDocumentApi(id);
      return ok(data, 'Deleted successfully.');
    } catch (error) {
      return fail(error);
    }
  };
};

export const downloadComplianceDocument = (id, fileName) => {
  return async () => {
    try {
      await api.downloadComplianceDocumentApi(id, fileName);
      return { success: true, message: 'Download started.' };
    } catch (error) {
      return fail(error);
    }
  };
};

export const viewComplianceDocument = (id) => {
  return async () => {
    const result = await api.viewComplianceDocumentBlob(id);
    if (result?.blob) {
      return {
        success: true,
        blob: result.blob,
        contentType: result.contentType || "",
      };
    }
    return { success: false };
  };
};

export const downloadComplianceDocumentsZip = (ids, filename) => {
  return async () => {
    try {
      await api.downloadComplianceDocumentsZipApi(ids, filename);
      return { success: true, message: 'Download started.' };
    } catch (error) {
      return fail(error);
    }
  };
};

export const releaseComplianceDocument = (id) => {
  return async () => {
    try {
      const data = await api.releaseComplianceDocumentApi(id);
      return ok(data, 'Document released.');
    } catch (error) {
      return fail(error);
    }
  };
};

export const releaseComplianceDocuments = (ids) => {
  return async () => {
    try {
      const data = await api.releaseComplianceDocumentsApi(ids);
      return ok(data, 'Documents released.');
    } catch (error) {
      return fail(error);
    }
  };
};

export const getComplianceDocumentCatalog = () => {
  return async () => {
    try {
      const data = await api.fetchComplianceDocumentCatalog();
      return { success: true, data: data?.categories || [] };
    } catch (error) {
      return fail(error);
    }
  };
};

export const createComplianceDocumentCatalog = (payload) => {
  return async () => {
    try {
      const data = await api.createComplianceDocumentCatalogApi(payload);
      return {
        success: true,
        message: data?.message || "Created successfully.",
        data: data?.data,
        categories: data?.categories || [],
      };
    } catch (error) {
      return fail(error);
    }
  };
};

export const deleteComplianceDocumentCatalog = (itemId) => {
  return async () => {
    try {
      const data = await api.deleteComplianceDocumentCatalogApi(itemId);
      return {
        success: true,
        message: data?.message || "Deleted successfully.",
        categories: data?.categories || [],
      };
    } catch (error) {
      return fail(error);
    }
  };
};
